export default __webpack_public_path__ + "static/2-9556f3baf4060d23a4e3da17c2e68ba2.webp";